export const themeDark = {
  textColor: 'text-neutral-400',
  textHoverColor: 'text-white',
  borderColor: 'border-neutral-800'
};

export const themeLight = {
  borderColor: 'border-neutral-200',
  textColor: 'text-black',
  textHoverColor: 'text-grey-800'
};
